import { useAuthUser } from "@/lib/auth-context";
import { Navigate, Outlet } from "react-router-dom";
import { RouteSpinner } from "../RouteSpinner";

export function RequireMemberOrAdmin(): JSX.Element {
  const { isLoaded, user } = useAuthUser();
  if (!isLoaded) return <RouteSpinner />;
  // Every authenticated user (member or admin) qualifies. Admins are allowed
  // through for preview — the page renders a banner + disables submit.
  if (!user) return <Navigate to="/" replace />;
  return <Outlet />;
}
